"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DataTable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableHead = _interopRequireDefault(require("./TableHead"));

var _TableData = _interopRequireDefault(require("./TableData"));

require("../assets/css/font-face.css");

require("./DataTable.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DataTable = function DataTable(_ref) {
  var rows = _ref.rows,
      cols = _ref.cols,
      withCheckbox = _ref.withCheckbox,
      customEmptyMessage = _ref.customEmptyMessage,
      onClick = _ref.onClick,
      onSelect = _ref.onSelect,
      className = _ref.className;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = (0, _react.useState)(rows),
      _useState4 = _slicedToArray(_useState3, 2),
      bodyRows = _useState4[0],
      setBodyRows = _useState4[1];

  var _useState5 = (0, _react.useState)('asc'),
      _useState6 = _slicedToArray(_useState5, 2),
      sortType = _useState6[0],
      setSortType = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      sortColumn = _useState8[0],
      setSortColumn = _useState8[1];

  (0, _react.useEffect)(function () {
    setBodyRows(rows);
  }, [rows]);
  var wrapperClass = 'data-table';
  if (className) wrapperClass += " ".concat(className); // return the current selected rows to onSelect callback

  if (onSelect) onSelect(selectedRows);

  var updateSelectedRows = function updateSelectedRows(id) {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter(function (selected) {
        return selected !== id;
      }));
    } else {
      setSelectedRows([].concat(_toConsumableArray(selectedRows), [id]));
    }
  };

  var selectAllRows = function selectAllRows() {
    var allRows = bodyRows.map(function (row) {
      return row.id;
    });

    if (allRows.length === selectedRows.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(allRows);
    }
  };

  var sortTable = function sortTable(array, column) {
    return array.sort(function (a, b) {
      var first = a[column];
      var second = b[column];

      if (_typeof(first) === 'object' && first.constructor === Object) {
        first = a[column].value;
        second = b[column].value;
      }

      if (first > second && sortType === 'desc') return -1;
      if (first < second && sortType === 'asc') return -1;
      return 0;
    });
  };

  var toggleSortType = function toggleSortType() {
    sortType === 'asc' ? setSortType('desc') : setSortType('asc');
  };

  var sortBy = function sortBy(id) {
    if (!id) return;
    var sortedBodyRows;
    setSortColumn(id);
    toggleSortType();
    sortedBodyRows = sortTable(bodyRows, id);
    setBodyRows(_toConsumableArray(sortedBodyRows));
  };

  return _react.default.createElement("div", {
    className: wrapperClass
  }, bodyRows.length ? _react.default.createElement("table", {
    className: "data-table__table"
  }, _react.default.createElement(_TableHead.default, {
    cols: cols,
    withCheckbox: withCheckbox,
    selectAllRows: selectAllRows,
    selected: selectedRows.length === bodyRows.length ? true : false,
    sortType: sortType,
    sortColumn: sortColumn,
    sortBy: sortBy
  }), _react.default.createElement("tbody", null, bodyRows.map(function (row) {
    return _react.default.createElement(_TableData.default, {
      data: row,
      id: row.id,
      key: row.id,
      selected: selectedRows.includes(row.id),
      onClick: onClick,
      withCheckbox: withCheckbox,
      updateSelectedRows: updateSelectedRows
    });
  }))) : _react.default.createElement("p", {
    className: "data-table__empty"
  }, customEmptyMessage));
};

exports.DataTable = DataTable;
DataTable.defaultProps = {
  rows: [],
  cols: [],
  withCheckbox: false,
  customEmptyMessage: 'Você não possui nenhum dado :(',
  onClick: null,
  onSelect: null
};
DataTable.propTypes = {
  /** Colunas da tabela */
  cols: _propTypes.default.array,

  /** Linhas da tabela */
  rows: _propTypes.default.array,

  /** Exibe os checkboxes à esqueda da tabela */
  withCheckbox: _propTypes.default.bool,

  /** Mensagem customizada para quando a tabela estiver vazia */
  customEmptyMessage: _propTypes.default.string,

  /** Função de callback executada após realizar cliques nas linhas */
  onClick: _propTypes.default.func,

  /** Função de callback executada após selecionar um ou mais checkbox */
  onSelect: _propTypes.default.func
};
var _default = DataTable;
exports.default = _default;